module.exports = __webpack_public_path__ + "img/jakie.0f6323d7.jpeg";